<div class="ptl-competency-scale" role="group" [attr.aria-label]="'Competency scale'">
  <div class="left-col" aria-hidden="false">
    @if (feedbackRecipient || isMockView) {
      <div class="label-row">
        <div class="label-name">
          {{ 'translations.selfRating' | transloco }}
        </div>
        <div class="label-pill label-pill--self" [attr.title]="selfPillLabel">{{ selfPillLabel }}</div>
      </div>
    }

    <div class="label-row">
      <div class="label-name">{{ 'translations.evaluatorAvgRating' | transloco }}</div>
      <div class="label-pill label-pill--avg" [attr.title]="avgPillLabel">{{ avgPillLabel }}</div>
    </div>
  </div>

  <div class="scale-col">
    <div class="scale-track" role="presentation">
      <div class="baseline" role="presentation"></div>

      <div class="bands" role="presentation">
        <ng-container *ngFor="let b of bands">
          <div class="band" [style.left.%]="b.start" [style.width.%]="b.end - b.start" role="presentation" aria-hidden="true">
            <div class="band-title" *ngIf="b.title" aria-hidden="true">{{ b.title }}</div>
          </div>
        </ng-container>
      </div>

      <div class="level-separators" aria-hidden="true">
        @for (b of bands; track b) {
          @if ($first) {
            <span class="band-separator" [style.left.%]="b.minPercent"></span>
            @if (labelFormat !== LabelFormat.PERCENT) {
              <span class="band-min" [style.left.%]="b.minPercent">{{ b.min }}</span>
            }
          }

          <span class="band-separator" [style.left.%]="b.separatorPercent"></span>
          @if ($last && labelFormat !== LabelFormat.PERCENT) {
            <span class="band-max" [style.left.%]="b.maxPercent">{{ b.max }}</span>
          }
        }
      </div>

      <div class="ticks" aria-hidden="true">
        <ng-container *ngFor="let t of ticks">
          <span class="tick" [style.left.%]="t"></span>
        </ng-container>
      </div>

      @if (chartType === ScoredChartType.BAR) {
        @if (feedbackRecipient || isMockView) {
          <div
            class="bar-indicator bar--self"
            ogAnimateOnScroll
            (visible)="selfVisible = true"
            [style.width.%]="selfVisible ? selfPercent : 0"
            [style.--bar-width]="selfPercent + '%'"
          >
            <span class="bar-label">{{ selfMarkerLabel }}</span>
          </div>
        }

        <div
          class="bar-indicator bar--avg"
          ogAnimateOnScroll
          (visible)="avgVisible = true"
          [style.width.%]="avgVisible ? avgPercent : 0"
          [style.--bar-width]="avgPercent + '%'"
        >
          <span class="bar-label">{{ avgMarkerLabel }}</span>
        </div>
      } @else {
        @if (feedbackRecipient || isMockView) {
          <div class="marker marker--self" [style.left.%]="selfPercent" [attr.title]="selfMarkerLabel">
            <span class="marker-pin" aria-hidden="true"></span>
            <span class="marker-value">{{ selfMarkerLabel }}</span>
          </div>
        }

        <div class="marker marker--avg" [style.left.%]="avgPercent" [attr.title]="avgMarkerLabel">
          <span class="marker-pin" aria-hidden="true"></span>
          <span class="marker-value">{{ avgMarkerLabel }}</span>
        </div>
      }
    </div>
  </div>
</div>
